import { useBooleanFlagValue } from '@openfeature/react-sdk';

import { useAssetApprovalsHidden } from '@/shared/hooks/useAssetApprovalsHidden';

/**
 * Whether the approval-chain affordances should render.
 *
 * Chains live inside asset approvals, so `hide_asset_approvals` dominates the
 * rollout switch: with it on, `workflow_management` has no observable effect
 * here. Most readers sit under the folders route guard and are covered by it
 * structurally; this hook is what keeps the relationship true for the ones
 * that do not, starting with the project shell, which renders on every section.
 */
export function useApprovalChainsEnabled(): boolean {
  // Both reads happen unconditionally: `&&` short-circuits, and skipping the
  // second hook call would break the rules of hooks.
  const workflowManagementEnabled = useBooleanFlagValue('workflow_management', false);
  const assetApprovalsHidden = useAssetApprovalsHidden();

  return workflowManagementEnabled && !assetApprovalsHidden;
}
